import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import JuniorHeader from'../Component/JuniorHeader'
const Attendance = () => { 
    useEffect(() => {
        document.title = ' Attendance - Sacread Heart Kharagpur';  
    }, []); 
  return (
     <>
     <JuniorHeader/>
       <div className="innerslide">
            <ul className="breadcrumb">
                <li><Link to="/"> Home</Link> </li> 
                <li>  Academic</li>
                 <li>Attendance</li>
            </ul>
        </div> 
        <div className="innersec">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <h1>Attendance</h1>
                    </div>
                </div>
                <div className="row">
                     <div className="col-12">
                     <ul className="list newlist">
                     <li> Regular attendance at school is in the interest of the students. It builds up a sense of devotion to duty and a habit for regularity and discipline. The students should arrive on time to the school. Parents co-operation is needed so that punctuality is ensured. 
                     </li>
                     <li> Students who have been absent from class must have the reason entered in the Regularity Record in the School Diary, stating briefly the case of the absence under absence column. A student who is absent or delay Reasons of a private nature may be duly signed by the parents of the guardians of the children and countersigned by the appropriate school authority. </li>
                     <li>Irregular attendance, habitual illeness,disobedience or misconduct injurious to the moral tone of the school are sufficient reasons for adopting strict disciplinary measures which may even lead to dismissal of student from the school. Those whose attendance falls short of 85% may be debarred from appearing for the examination. </li>
                     <li> Absence from class for birthdays, marriages, feasts, excursions in view of anticipating of extending school vacations or in order to study are not encouraged. If a student is absent for fifteen consecutive days his name may be struck off the rolls. </li>
                     <li> No child will be permitted to leave the school during class hours without special permission of the Principal and only if a written request from the parent is submitted. </li>
                     <li> All the school children should have Identity Cards obtainable from the school office. It is advisable for K.G. children that the person authorised to take the pupil home should have the school authority's acknowledgement. </li> </ul>
 </div>
                </div>
            </div>
        </div>
     </>
  )
}

export default Attendance

